export type QuestionDef = {
  key: string
  choiceKeys: string[]
}

export const OILY_DRY_QUESTIONS: QuestionDef[] = [
  { key: 'afterWashing',            choiceKeys: ['rough', 'tight', 'hydrated', 'shiny'] },
  { key: 'soapReaction',            choiceKeys: ['dry', 'slightlyDry', 'normal', 'noSoap'] },
  { key: 'afterMoisturizerCheeks',  choiceKeys: ['rough', 'smooth', 'slightlyShiny', 'shiny', 'noMoisturizer'] },
  { key: 'photoShine',              choiceKeys: ['never', 'sometimes', 'frequently', 'always'] },
  { key: 'lowHumiditySkin',         choiceKeys: ['tight', 'slightlyDry', 'normal', 'oily', 'dontKnow'] },
  { key: 'characterizeSkin',        choiceKeys: ['dry', 'normal', 'combination', 'oily'] },
  { key: 'cloggedPores',            choiceKeys: ['never', 'rarely', 'sometimes', 'always'] },
  { key: 'largePores',              choiceKeys: ['none', 'few', 'many', 'dontKnow'] },
  { key: 'tightWithoutMoisturizer', choiceKeys: ['always', 'sometimes', 'rarely', 'never'] },
]

export const SENSITIVE_RESISTANT_QUESTIONS: QuestionDef[] = [
  { key: 'redPimples',               choiceKeys: ['never', 'rarely', 'monthly', 'weekly'] },
  { key: 'productReaction',          choiceKeys: ['never', 'rarely', 'often', 'always'] },
  { key: 'shavingReaction',          choiceKeys: ['never', 'rarely', 'often', 'always'] },
  { key: 'acneRosaceaDiagnosis',     choiceKeys: ['no', 'yes', 'yesSevere', 'unsure'] },
  { key: 'jewelryRash',              choiceKeys: ['never', 'rarely', 'often', 'always', 'unsure'] },
  { key: 'sunscreenReaction',        choiceKeys: ['never', 'rarely', 'often', 'always'] },
  { key: 'dermatitisDiagnosis',      choiceKeys: ['no', 'yes', 'yesSevere', 'unsure'] },
  { key: 'hotelSoap',                choiceKeys: ['yes', 'sometimes', 'no', 'unsure'] },
  { key: 'familyHistory',            choiceKeys: ['no', 'oneMember', 'severalMembers', 'manyMembers', 'unsure'] },
  { key: 'laundryDetergentReaction', choiceKeys: ['fine', 'slightlyDry', 'itches', 'itchyRash', 'unsure'] },
  { key: 'exerciseFlushing',         choiceKeys: ['never', 'sometimes', 'frequently', 'always'] },
  { key: 'alcoholFlushing',          choiceKeys: ['never', 'sometimes', 'frequently', 'always', 'neverDrink'] },
  { key: 'foodFlushing',             choiceKeys: ['never', 'sometimes', 'frequently', 'always'] },
  { key: 'brokenBloodVessels',       choiceKeys: ['none', 'few', 'some', 'many'] },
  { key: 'photoRedness',             choiceKeys: ['never', 'sometimes', 'frequently', 'always'] },
  { key: 'sunburnComments',          choiceKeys: ['never', 'sometimes', 'frequently', 'always'] },
]

export const PIGMENTED_QUESTIONS: QuestionDef[] = [
  { key: 'melasmaDiagnosis',       choiceKeys: ['no', 'yesGone', 'yesHave', 'yesSevere', 'unsure'] },
  { key: 'hormoneDarkPatches',     choiceKeys: ['none', 'one', 'few', 'lot', 'notApplicable'] },
  { key: 'lipCheekPatches',        choiceKeys: ['no', 'yesSlightly', 'yesNoticeable'] },
  { key: 'sunWorsensPatches',      choiceKeys: ['noPatches', 'unsure', 'slightlyWorse', 'lotWorse'] },
  { key: 'pimpleDarkSpot',         choiceKeys: ['never', 'sometimes', 'frequently', 'always', 'noPimples'] },
  { key: 'scarMarkDuration',       choiceKeys: ['noMark', 'week', 'fewWeeks', 'months'] },
  { key: 'frecklePresence',        choiceKeys: ['no', 'few', 'many', 'tons'] },
  { key: 'initialSunExposure',     choiceKeys: ['burnOnly', 'burnThenTan', 'tan', 'alreadyDark'] },
  { key: 'consecutiveSunExposure', choiceKeys: ['burnBlister', 'slightlyDarker', 'muchDarker', 'alreadyDark', 'unsure'] },
  { key: 'hairColor',              choiceKeys: ['blond', 'brown', 'black', 'red'] },
  { key: 'sunSpotPresence',        choiceKeys: ['yes', 'no'] },
]

export const WRINKLED_QUESTIONS: QuestionDef[] = [
  { key: 'motherAge',              choiceKeys: ['younger', 'age', 'older', 'muchOlder', 'notApplicable'] },
  { key: 'fatherAge',              choiceKeys: ['younger', 'age', 'older', 'muchOlder', 'notApplicable'] },
  { key: 'maternalGrandmotherAge', choiceKeys: ['younger', 'age', 'older', 'muchOlder', 'notApplicable'] },
  { key: 'maternalGrandfatherAge', choiceKeys: ['younger', 'age', 'older', 'muchOlder', 'notApplicable'] },
  { key: 'paternalGrandmotherAge', choiceKeys: ['younger', 'age', 'older', 'muchOlder', 'notApplicable'] },
  { key: 'paternalGrandfatherAge', choiceKeys: ['younger', 'age', 'older', 'muchOlder', 'notApplicable'] },
  { key: 'ongoingTanning',         choiceKeys: ['never', 'oneToFive', 'fiveToTen', 'moreThanTen'] },
  { key: 'seasonalTanning',        choiceKeys: ['never', 'oneToFive', 'fiveToTen', 'moreThanTen'] },
  { key: 'dailySunExposure',       choiceKeys: ['little', 'some', 'moderate', 'lot'] },
  { key: 'perceivedAge',           choiceKeys: ['younger', 'age', 'older', 'muchOlder'] },
  { key: 'recentTanning',          choiceKeys: ['never', 'monthly', 'weekly', 'daily'] },
  { key: 'tanningBedUse',          choiceKeys: ['never', 'oneToFive', 'fiveToTen', 'many'] },
  { key: 'smokingHistory',         choiceKeys: ['none', 'few', 'many', 'secondHand'] },
  { key: 'airPollution',           choiceKeys: ['clean', 'varies', 'slightlyPolluted', 'veryPolluted'] },
  { key: 'retinoidUse',            choiceKeys: ['manyYears', 'occasionally', 'once', 'never'] },
  { key: 'currentDietFruitsVeg',   choiceKeys: ['everyMeal', 'onceDaily', 'occasionally', 'never'] },
  { key: 'lifetimeDietFruitsVeg',  choiceKeys: ['75-100', '25-75', '10-25', '0-10'] },
  { key: 'naturalSkinColor',       choiceKeys: ['dark', 'medium', 'light', 'veryLight'] },
]
